import { FunctionDeclaration, SchemaType } from "@google/generative-ai";
import { ToolHandler } from "./types";
import { ToolCall } from "../multimodal-live-types";
import { MultimodalLiveClient } from "../lib/multimodal-live-client";

export const altairToolDeclaration: FunctionDeclaration = {
  name: "render_altair",
  description: "Displays an altair graph in json format.",
  parameters: {
    type: SchemaType.OBJECT,
    properties: {
      json_graph: {
        type: SchemaType.STRING,
        description:
          "JSON STRING representation of the graph to render. Must be a string, not a json object",
      },
    },
    required: ["json_graph"],
  },
};

export class AltairTool implements ToolHandler {
  name = "render_altair";
  declaration = altairToolDeclaration;
  private setJSONString: (jsonString: string) => void;

  constructor(setJSONString: (jsonString: string) => void) {
    this.setJSONString = setJSONString;
  }

  async handleToolCall(toolCall: ToolCall, client: MultimodalLiveClient): Promise<void> {
    console.log(`Handling altair tool call`, toolCall);
    
    // With the updated ToolRegistry, toolCall will only contain the relevant functionCall
    const functionCall = toolCall.functionCalls[0];
    
    if (functionCall && functionCall.name === this.name) {
      const str = (functionCall.args as any).json_graph;
      this.setJSONString(str);
      
      // Send response back to the client
      setTimeout(
        () =>
          client.sendToolResponse({
            functionResponses: [{
              response: { output: { success: true } },
              id: functionCall.id,
            }],
          }),
        200,
      );
    }
  }
}
